import { safeApi, apiClient } from "../../utils/axiosWithAuth";
import { ApiResponse } from "../../utils/axiosWithAuth";
import { 
  CategoryLookupDTO, 
  SupplierDTO, 
  TaxDTO, 
  LocationDTO, 
  CreateInventoryItemDTO, 
  CreateItemResponse,
  InventoryItemDTO,
  InventoryItemListResponse
} from "../../types/inventory";

// Re-export types for backward compatibility
export type { CategoryLookupDTO as CategoryDTO };
export type { SupplierDTO, TaxDTO, LocationDTO, CreateInventoryItemDTO as CreateItemDTO, CreateItemResponse, InventoryItemDTO };

export interface InventorySettings {
  stockLevelThresholds: { lowMax: number; mediumMax: number };
}

export const fetchInventorySettingsAPI = () =>
  safeApi<InventorySettings>(() =>
    apiClient.get<ApiResponse<InventorySettings>>('/inventory/settings')
  );

/** ----- Lookups ----- */
export const fetchCategoriesAPI = () =>
  safeApi<CategoryLookupDTO[]>(() =>
    apiClient.get<ApiResponse<CategoryLookupDTO[]>>("/categories")
  );

export const fetchSuppliersAPI = () =>
  safeApi<SupplierDTO[]>(() =>
    apiClient.get<ApiResponse<SupplierDTO[]>>("/suppliers")
  );

export const fetchTaxesAPI = () =>
  safeApi<TaxDTO[]>(() =>
    apiClient.get<ApiResponse<TaxDTO[]>>("/taxes")
  );

export const fetchLocationsAPI = () =>
  safeApi<LocationDTO[]>(() =>
    apiClient.get<ApiResponse<LocationDTO[]>>("/locations")
  );

/** ----- Create item (multipart) ----- */
export const createItemAPI = (dto: CreateInventoryItemDTO) => {
  const fd = new FormData();
  fd.append('item_code', dto.item_code);
  fd.append('item_name', dto.item_name);
  fd.append('description', dto.description ?? '');
  fd.append('category', dto.category);
  fd.append('supplier', dto.supplier);
  fd.append('cost_price', String(dto.cost_price));
  fd.append('selling_price', String(dto.selling_price));
  fd.append('tax', String(dto.tax));
  fd.append('quantity_in_stock', String(dto.quantity_in_stock));
  fd.append('storeId', dto.storeId);
  fd.append('status', dto.status);
  if (dto.product_image instanceof File) {
    fd.append('product_image', dto.product_image);
  }

  return safeApi<CreateItemResponse>(() =>
    apiClient.post<ApiResponse<CreateItemResponse>>("inventory/items", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  );
};

/** ----- Fetch items ----- */
export const fetchItemsAPI = (page = 1, limit = 10, search?: string, status?: string, categoryId?: string, store?: string, supplierId?: string, stockLevel?: string) =>
  safeApi<InventoryItemListResponse>(() =>
    apiClient.get<ApiResponse<InventoryItemListResponse>>(
      `/inventory/items?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}${
        status ? `&status=${status}` : ''
      }${categoryId ? `&category=${categoryId}` : ''}${
        store ? `&store=${store}` : ''
      }${supplierId ? `&supplier=${supplierId}` : ''}${stockLevel ? `&stockLevel=${stockLevel}` : ''}`
    )
  );

export const fetchOneItemAPI = (uuid: string) =>
  safeApi<InventoryItemDTO>(() =>
    apiClient.get<ApiResponse<InventoryItemDTO>>(`/inventory/items/${uuid}`)
  );
